export const getCareOrchestrationIsLoading = (state) => state.careOrchestration?.isLoading;
export const getCareOrchestrationError = (state) => state.careOrchestration?.error;
export const getCareOrchestrationStats = (state) => state.careOrchestration?.stats;
export const getCareOrchestrationMeta = (state) => state.careOrchestration?.meta;
export const getCareOrchestrationLastFetchedAt = (state) => state.careOrchestration?.lastFetchedAt;
export const getCareOrchestrationCapacityTasks = (state) =>
  state.careOrchestration?.capacityTasks || [];
export const getCareOrchestrationCapacityTasksLoaded = (state) =>
  !!state.careOrchestration?.capacityTasksLoaded;
